/**
 * Vite entry. Mounts <App/> into #root and pulls in the global stylesheet
 * which imports `@sill/ui/css/reset` and `@sill/ui/css/theme`. <FontLoader/>
 * is mounted inside <App/> (under the ThemeProvider) rather than here so the
 * lifecycle is tied to the app tree.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { capturePlanIntentFromUrl } from './lib/plan-intent.js';
import './styles/globals.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Sill dashboard: #root element missing from index.html');
}

// Plan chosen on sill.so/pricing (`/sign-up?plan=&interval=`). Read
// once, before any view mounts, so it survives whichever screen the
// visitor lands on (sign-in form, or home when already signed in).
// Validated and stored as a hint only; it grants nothing.
if (window.location.pathname === '/sign-up') {
  capturePlanIntentFromUrl(new URL(window.location.href));
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
